<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_system_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="システム（詳細）" >
            <div>
            </div>
          </title-and-slot>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
                            <button class="btn btn-primary" style="min-width:100px;float: left;margin-left: -10px;" @click="backToList" >＜　戻る</button>
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <!-- Coll A -->
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-4" style="">
              <!-- Coll B -->
              <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-4" style="">
              <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
              <!-- Coll C -->
            </div>

          </div>
          <div class="col-xs-8" style="">
          <div class="row" style="margin-bottom:10px;">

              <button v-if="read_only == false"  class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:2px;background: #92D050;border-color:#92D050;"  @click="onSave" >登録</button>
              <button
              :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
              v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;margin-right:2px;" @click="onEdit"  >編集</button>
              <button v-if="read_only == false" :disabled="false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #A6A6A6;border-color:#A6A6A6;" @click="btnCancel" >キャンセル</button>
              <button
              :disabled="checkUserPermission(true,permissionMode.DELETE) == false"
              v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">削除</button>
          </div>
          </div>
      </div>
      <confirmation-modal tag="deleteMasterSystemModal" @done="onConfirmDelete" />
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_master_system';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:master_belong_details');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import constants from "@/rules/constants";
import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
  },
  data() {
    return {
      api_name:"master_system",
      page_acl: acl.master
    };
  },
  computed: {
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(fields.system_code, {}),
          utils.extend(fields.system_name, {}),
        ],
        col2:[
          utils.extend(fields.company, {}),
          utils.extend(fields.equipment_in_charge_department, {}),
          utils.extend(fields.system_jurisdiction_team, {}),
        ],
        col3:[
        ],
      }
    }
  },
  methods: {
    onSave(){
      var field_name_arr = ["system_code","system_name","company","equipment_in_charge_department","system_jurisdiction_team"];
      this.commonSaveIfNotBlank(this,this.api_name, {} ,field_name_arr);
    },
    onEdit(){
      mdebug("onEdit")
      this.startCompanySelection();
      this.commonOnEdit();
    },
    onDelete(){
      bus.$emit("deleteMasterSystemModal",{
        title: "削除",
        message: "システムの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        this.commonDelete(this);
      }
    },
    backToList(){
      return this.$router.push({ name: "page_0041_master_system", params: {} });
    },
    prepareCompanySelection( companies, department_and_team, company_field, department_field, team_field, company_field_name, department_field_name ) {


      var selected_company = false;
      var selected_department = false;
      company_field.page_controller_setup({
        on_select: (_selected_company) => {
          selected_company = _selected_company;
          if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = _.uniq(
              _.map(
                _.filter(department_and_team || [], (d) => {
                  return d.company == selected_company;
                }) || [],
                "department"
              ) || []
            );
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: true,
            });
          }
        },
      });
      department_field.page_controller_setup({
        on_select: (_selected_department) => {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = _.uniq(
              _.map(
                _.filter(department_and_team || [], (d) => {
                  return (
                    d.company == selected_company &&
                    d.department == selected_department
                  );
                }) || [],
                "team"
              ) || []
            );
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({cmd:"set_value",val:""})
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: true,
            });
          }
        },
      });
      company_field.page_controller_msg({
        cmd: "set_options",
        options: _.clone(companies),
      });
      company_field.page_controller_msg({ cmd: "enable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
      setTimeout(
        () => {
          department_field.page_controller_msg({ cmd: "enable_if_data" });
          team_field.page_controller_msg({ cmd: "enable_if_data" });

          selected_company = this.$store.state[this.stateCurrentRow][company_field.id];
          selected_department = this.$store.state[this.stateCurrentRow][department_field.id];
          if (selected_company && selected_company.length > 0) {
            var departments = _.uniq(
              _.map(
                _.filter(department_and_team || [], (d) => {
                  return d.company == selected_company;
                }) || [],
                "department"
              ) || []
            );
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: false,
            });
            department_field.page_controller_msg({ cmd: "enable" });
            if (selected_department && selected_department.length > 0) {
              var teams = _.uniq(
                _.map(
                  _.filter(department_and_team || [], (d) => {
                    return (
                      d.company == selected_company &&
                      d.department == selected_department
                    );
                  }) || [],
                  "team"
                ) || []
              );
              team_field.page_controller_msg({
                cmd: "set_options",
                options: teams,
                reset: false,
              });
            }
          }

          if(this.isSurplus){
            setTimeout(() => {
              // var departments = _.uniq(_.map(_.filter(department_and_team || [], (d) => {return d.company == selected_company;}) || [],"department") || []);
              // departments.unshift("");
              department_field.page_controller_msg({ cmd: "enable" });
              // department_field.page_controller_msg({ cmd: "set_value", val: "" });
              // team_field.page_controller_msg({ cmd: "set_value", val: "" });
              // team_field.page_controller_msg({ cmd: "disable" });
              // department_field.page_controller_msg({
              //   cmd: "set_options",
              //   options: departments,
              //   reset: true,
              // });
            }, 500);
          }
        },
        this.is_new ? 100 : 500
      );
    },
    startCompanySelection(){
      if(this.company_selection_started == true){
        return;
      }
      this.company_selection_started  = true;
      if (true) {
        var temp_fields = this.installedFieldList;
        // Load the companies
        this.$ajax.post_cached_queued(
          "/master_company/list_company_name",
          {},
          (err, _companies) => {
            if (err) {
              this.$notify({
                title: "所管会社のデータが読込めませんでした。",
                text: err,
                type: "error",
                duration: 10000,
              });
              return;
            }
            var companies = [""];
            _companies.forEach((c) => {
              companies.push(c.val);
            });
            // Load the departments and teams
            this.$ajax.post_cached_queued(
              "/master_belongs/list_team_and_department",
              {},
              (err, department_and_team) => {
                if (err) {
                  this.$notify({
                    title: "部署・チームのデータの読込に失敗しました。",
                    text: err,
                    type: "error",
                    duration: 10000,
                  });
                  return;
                }
                this.prepareCompanySelection(
                  _.clone(companies),
                  _.clone(department_and_team),
                  temp_fields.company,
                  temp_fields.equipment_in_charge_department,
                  temp_fields.system_jurisdiction_team,
                  "company",
                  "department"
                );
                if (this.$route.params.seq_id == "new") {
                  var default_company = Vue.localStorage.get(
                    temp_fields.company.default_from_local_storage
                  );
                  if (default_company != constants.COMPANY.ALL) {
                    setTimeout(
                      () => {
                        var default_deparment = Vue.localStorage.get(
                          temp_fields.equipment_in_charge_department
                            .default_from_local_storage
                        );
                        var default_team = Vue.localStorage.get(
                          temp_fields.system_jurisdiction_team
                            .default_from_local_storage
                        );
                        temp_fields.company.page_controller_msg({
                          cmd: "set_value",
                          val: default_company,
                        });
                        temp_fields.equipment_in_charge_department.page_controller_msg({
                          cmd: "set_value",
                          val: default_deparment,
                        });
                        temp_fields.system_jurisdiction_team.page_controller_msg(
                          { cmd: "set_value", val: default_team }
                        );
                      },
                      this.is_new ? 300 : 1000
                    );
                  }
                }
              }
            );
          }
        );
      }
    }
  },
  mounted() {
    if (this.$route.params.seq_id == "new") {
      setTimeout(() => {
        this.startCompanySelection();
      }, 10);
    }
    this.commonLoadRecord({},(err,result)=>{
      this.commonEditDeleteCmdHandler(this);
    })
  },
  beforeDestroy() {
  },
  beforeMount() {
  }
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0041_master_system_detail.vue?410ede9a